module.exports = __webpack_public_path__ + "img/1589888955.bfb9ec8c.jpg";